import $axios from "@/utils/axios";

/**
 * 招聘管理-候选人
 */
export default {
  namespaced: true,
  state: () => ({
    // 流程列表
    processList: [
      // {
      //   id: "",
      //   code: "", // 编码
      //   name: "", // 名称
      //   type: "", // 类型，process-流程，processPhase-阶段，processStatus-状态
      //   children: []
      // },
    ],
  }),
  getters: {
    processList: (state) => state.processList,
    getProcessOptions: (state) => {
      return (processCode, processPhaseCode) => {
        let options = state.processList.find(item => item.code === processCode)?.children || []

        if (processPhaseCode) {
          options = options.find(item => item.code === processPhaseCode)?.children || []
        }

        return options
      }
    }
  },
  mutations: {
    setProcessList(state, payload = []) {
      state.processList = payload;
    },
  },
  actions: {
    /**
     * 获取所有生效流程数据
     */
    async fetchProcessList({ commit, state }) {
      try {
        if (state.processList.length) return;

        let { data } = await $axios.post(
          `/${process.env.VUE_APP_RECRUIT}/hrRecruitProcess/findAll`,
          {},
          { type: "form", uselsmyAccount: true }
        );

        let listData = data.map(
          ({ processCode, processId, processName, phaseList }) => {
            let tmp = {
              code: processCode,
              id: processId,
              name: processName,
              children: [],
              type: "process",
            };

            tmp.children = phaseList.map(
              ({
                processPhaseCode,
                processPhaseId,
                processPhaseName,
                statusList,
              }) => {
                return {
                  code: processPhaseCode,
                  id: processPhaseId,
                  name: processPhaseName,
                  type: "processPhase",
                  children: statusList.map(
                    ({
                      processStatusCode,
                      processStatusId,
                      processStatusName,
                    }) => ({
                      code: processStatusCode,
                      id: processStatusId,
                      name: processStatusName,
                      type: "processStatus",
                    })
                  ),
                };
              }
            );

            return tmp;
          }
        );

        commit("setProcessList", listData);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
